
export const TEMPLATE_FRAGMENTS = [
  // Scorecard fragments (split for DynamoDB size limits)
  {
    name: 'Scorecard-Part1',
    displayName: 'Scorecard Settings (Part 1)',
    fields: [
      'coachingCdfDpmoThresholdIssue',
      'coachingCdfDpmoThreshold',
      'coachingCdfDpmoThresholdPR',
      'coachingCdfDpmoThresholdKudo',
      'coachingCdfDpmoIssue',
      'coachingCdfDpmoPR',
      'coachingCdfDpmoCO',
      'coachingCdfDpmoKudo',
      'coachingCdfDpmoRatingIssue',
      'coachingCdfDpmoRatingKudo',
      'coachingConsecutiveTierThresholdIssue',
      'coachingConsecutiveTierThresholdKudo',
      'coachingConsecutiveTierIssue',
      'coachingConsecutiveTierKudo',
      'coachingConsecutiveTierRatingIssue',
      'coachingConsecutiveTierRatingKudo',
      'coachingDarThresholdIssue',
      'coachingDarThreshold',
      'coachingDarThresholdPR',
      'coachingDarThresholdKudo',
      'coachingDarIssue',
      'coachingDarPR',
      'coachingDarCO',
      'coachingDarKudo',
      'coachingDcrThresholdIssue',
      'coachingDcrThreshold',
      'coachingDcrThresholdPR',
      'coachingDcrThresholdKudo',
      'coachingDcrIssue',
      'coachingDcrPR',
      'coachingDcrCO',
      'coachingDcrKudo',
      'coachingDcDpmoThresholdIssue',
      'coachingDcDpmoThreshold',
      'coachingDcDpmoThresholdPR',
      'coachingDcDpmoThresholdKudo',
      'coachingDcDpmoIssue',
      'coachingDcDpmoPR',
      'coachingDcDpmoCO',
      'coachingDcDpmoKudo'
    ]
  },

  {
    name: 'Scorecard-Part2',
    displayName: 'Scorecard Settings (Part 2)',
    fields: [
      'coachingDistractionsRateThresholdIssue',
      'coachingDistractionsRateThreshold',
      'coachingDistractionsRateThresholdPR',
      'coachingDistractionsRateThresholdKudo',
      'coachingDistractionsRateIssue',
      'coachingDistractionsRatePR',
      'coachingDistractionsRateCO',
      'coachingDistractionsRateKudo',
      'coachingDnrThresholdIssue',
      'coachingDnrThreshold',
      'coachingDnrThresholdPR',
      'coachingDnrThresholdKudo',
      'coachingDnrIssue',
      'coachingDnrPR',
      'coachingDnrCO',
      'coachingDnrKudo',
      'coachingDsbThresholdIssue',
      'coachingDsbThreshold',
      'coachingDsbThresholdPR',
      'coachingDsbThresholdKudo',
      'coachingDsbIssue',
      'coachingDsbPR',
      'coachingDsbCO',
      'coachingDsbKudo',
      'coachingFicoThresholdIssue',
      'coachingFicoThreshold',
      'coachingFicoThresholdPR',
      'coachingFicoThresholdKudo',
      'coachingFicoIssue',
      'coachingFicoPR',
      'coachingFicoCO',
      'coachingFicoKudo'
    ]
  },

  {
    name: 'Scorecard-Part3',
    displayName: 'Scorecard Settings (Part 3)',
    fields: [
      'coachingFollowingDistanceRateThresholdIssue',
      'coachingFollowingDistanceRateThreshold',
      'coachingFollowingDistanceRateThresholdPR',
      'coachingFollowingDistanceRateThresholdKudo',
      'coachingFollowingDistanceRateIssue',
      'coachingFollowingDistanceRatePR',
      'coachingFollowingDistanceRateCO',
      'coachingFollowingDistanceRateKudo',
      'coachingHarshBrakingRateThresholdIssue',
      'coachingHarshBrakingRateThreshold',
      'coachingHarshBrakingRateThresholdPR',
      'coachingHarshBrakingRateThresholdKudo',
      'coachingHarshBrakingRateIssue',
      'coachingHarshBrakingRatePR',
      'coachingHarshBrakingRateCO',
      'coachingHarshBrakingRateKudo',
      'coachingHarshCorneringRateThresholdIssue',
      'coachingHarshCorneringRateThreshold',
      'coachingHarshCorneringRateThresholdPR',
      'coachingHarshCorneringRateThresholdKudo',
      'coachingHarshCorneringRateIssue',
      'coachingHarshCorneringRatePR',
      'coachingHarshCorneringRateCO',
      'coachingHarshCorneringRateKudo'
    ]
  },

  {
    name: 'Scorecard-Part4',
    displayName: 'Scorecard Settings (Part 4)',
    fields: [
      // OverallTier fields
      'coachingOverallTierThresholdIssue',
      'coachingOverallTierThresholdKudo',
      'coachingOverallTierIssue',
      'coachingOverallTierKudo',
      'coachingOverallTierRatingIssue',
      'coachingOverallTierRatingKudo',

      // SeatbeltOff fields
      'coachingSeatbeltOffThresholdIssue',
      'coachingSeatbeltOffThreshold',
      'coachingSeatbeltOffThresholdPR',
      'coachingSeatbeltOffThresholdKudo',
      'coachingSeatbeltOffIssue',
      'coachingSeatbeltOffPR',
      'coachingSeatbeltOffCO',
      'coachingSeatbeltOffKudo',

      // SignSignalViolationsRate fields
      'coachingSignSignalViolationsRateThresholdIssue',
      'coachingSignSignalViolationsRateThreshold',
      'coachingSignSignalViolationsRateThresholdPR',
      'coachingSignSignalViolationsRateThresholdKudo',
      'coachingSignSignalViolationsRateIssue',
      'coachingSignSignalViolationsRatePR',
      'coachingSignSignalViolationsRateCO',
      'coachingSignSignalViolationsRateKudo'
    ]
  },

  {
    name: 'Scorecard-Part5',
    displayName: 'Scorecard Settings (Part 5)',
    fields: [
      // SpeedingEvent fields
      'coachingSpeedingEventThresholdIssue',
      'coachingSpeedingEventThreshold',
      'coachingSpeedingEventThresholdPR',
      'coachingSpeedingEventThresholdKudo',
      'coachingSpeedingEventIssue',
      'coachingSpeedingEventPR',
      'coachingSpeedingEventCO',
      'coachingSpeedingEventKudo',

      // SwcPod fields
      'coachingSwcPodThresholdIssue',
      'coachingSwcPodThreshold',
      'coachingSwcPodThresholdPR',
      'coachingSwcPodThresholdKudo',
      'coachingSwcPodIssue',
      'coachingSwcPodPR',
      'coachingSwcPodCO',
      'coachingSwcPodKudo',

      // SwcSc fields
      'coachingSwcScThresholdIssue',
      'coachingSwcScThreshold',
      'coachingSwcScThresholdPR',
      'coachingSwcScThresholdKudo',
      'coachingSwcScIssue',
      'coachingSwcScPR',
      'coachingSwcScCO',
      'coachingSwcScKudo'
    ]
  },

  {
    name: 'CXFeedback',
    displayName: 'CX Feedback Settings',
    fields: [
      // CdfScore fields
      'coachingCdfScoreThresholdIssue',
      'coachingCdfScoreThreshold',
      'coachingCdfScoreThresholdPR',
      'coachingCdfScoreThresholdKudo',
      'coachingCdfScoreIssue',
      'coachingCdfScorePR',
      'coachingCdfScoreCO',
      'coachingCdfScoreKudo',
      'coachingCdfScoreRatingIssue',
      'coachingCdfScoreRatingKudo',

      // DaTier fields
      'coachingDaTierThresholdIssue',
      'coachingDaTierThresholdKudo',
      'coachingDaTierIssue',
      'coachingDaTierPR',
      'coachingDaTierCO',
      'coachingDaTierKudo',
      'coachingDaTierRatingIssue',
      'coachingDaTierRatingCO',
      'coachingDaTierRatingPR',
      'coachingDaTierRatingKudo'
    ]
  },

  {
    name: 'Mentor',
    displayName: 'Mentor Settings',
    fields: [
      // DailyFico fields
      'coachingDailyFicoThresholdIssue',
      'coachingDailyFicoThreshold',
      'coachingDailyFicoThresholdPR',
      'coachingDailyFicoThresholdKudo',
      'coachingDailyFicoIssue',
      'coachingDailyFicoPR',
      'coachingDailyFicoCO',
      'coachingDailyFicoKudo',

      // Seatbelt fields
      'coachingSeatbeltThresholdIssue',
      'coachingSeatbeltThreshold',
      'coachingSeatbeltThresholdPR',
      'coachingSeatbeltThresholdKudo',
      'coachingSeatbeltIssue',
      'coachingSeatbeltPR',
      'coachingSeatbeltCO',
      'coachingSeatbeltKudo',

      // Sse fields
      'coachingSseThresholdIssue',
      'coachingSseThreshold',
      'coachingSseThresholdPR',
      'coachingSseThresholdKudo',
      'coachingSseIssue',
      'coachingSsePR',
      'coachingSseCO',
      'coachingSseKudo',

      // TraningRemaining fields
      'coachingTraningRemainingIssue',
      'coachingTraningRemainingPR',
      'coachingTraningRemainingCO'
    ]
  },

  {
    name: 'Netradyne-Part1',
    displayName: 'Netradyne Settings (Part 1)',
    fields: [
      // DriverStar fields
      'coachingDriverStarThresholdPR',
      'coachingDriverStarThresholdKudo',
      'coachingDriverStarPR',
      'coachingDriverStarKudo',

      // CameraObstruction fields
      'coachingCameraObstructionThresholdIssue',
      'coachingCameraObstructionThreshold',
      'coachingCameraObstructionIssue',
      'coachingCameraObstructionCO',

      // DriverDistraction fields
      'coachingDriverDistractionThresholdIssue',
      'coachingDriverDistractionThreshold',
      'coachingDriverDistractionIssue',
      'coachingDriverDistractionCO',

      // DriverDrowsiness fields
      'coachingDriverDrowsinessThresholdIssue',
      'coachingDriverDrowsinessThreshold',
      'coachingDriverDrowsinessIssue',
      'coachingDriverDrowsinessCO',

      // FollowingDistance fields
      'coachingFollowingDistanceThresholdIssue',
      'coachingFollowingDistanceThreshold',
      'coachingFollowingDistanceIssue',
      'coachingFollowingDistanceCO'
    ]
  },

  {
    name: 'Netradyne-Part2',
    displayName: 'Netradyne Settings (Part 2)',
    fields: [
      // HardAcceleration fields
      'coachingHardAccelerationThresholdIssue',
      'coachingHardAccelerationThreshold',
      'coachingHardAccelerationIssue',
      'coachingHardAccelerationCO',

      // HardBraking fields
      'coachingHardBrakingThresholdIssue',
      'coachingHardBrakingThreshold',
      'coachingHardBrakingIssue',
      'coachingHardBrakingCO',

      // HardTurn fields
      'coachingHardTurnThresholdIssue',
      'coachingHardTurnThreshold',
      'coachingHardTurnIssue',
      'coachingHardTurnCO',

      // HighG fields
      'coachingHighGThresholdIssue',
      'coachingHighGThreshold',
      'coachingHighGIssue',
      'coachingHighGCO',

      // LowImpact fields
      'coachingLowImpactThresholdIssue',
      'coachingLowImpactThreshold',
      'coachingLowImpactIssue',
      'coachingLowImpactCO'
    ]
  },

  {
    name: 'Netradyne-Part3',
    displayName: 'Netradyne Settings (Part 3)',
    fields: [
      // SeatbeltCompliance fields
      'coachingSeatbeltComplianceThresholdIssue',
      'coachingSeatbeltComplianceThreshold',
      'coachingSeatbeltComplianceIssue',
      'coachingSeatbeltComplianceCO',

      // SignViolations fields
      'coachingSignViolationsThresholdIssue',
      'coachingSignViolationsThreshold',
      'coachingSignViolationsIssue',
      'coachingSignViolationsCO',

      // SpeedingViolations fields
      'coachingSpeedingViolationsThresholdIssue',
      'coachingSpeedingViolationsThreshold',
      'coachingSpeedingViolationsIssue',
      'coachingSpeedingViolationsCO',

      // TrafficLightViolation fields
      'coachingTrafficLightViolationThresholdIssue',
      'coachingTrafficLightViolationThreshold',
      'coachingTrafficLightViolationIssue',
      'coachingTrafficLightViolationCO',

      // UTurn fields
      'coachingUTurnThresholdIssue',
      'coachingUTurnThreshold',
      'coachingUTurnIssue',
      'coachingUTurnCO',

      // Weaving fields
      'coachingWeavingThresholdIssue',
      'coachingWeavingThreshold',
      'coachingWeavingIssue',
      'coachingWeavingCO'
    ]
  },

  {
    name: 'EOC',
    displayName: 'Engine Off Compliance Settings',
    fields: [
      // DailyComplianceRate fields
      'coachingDailyComplianceRateThresholdIssue',
      'coachingDailyComplianceRateThreshold',
      'coachingDailyComplianceRateThresholdPR',
      'coachingDailyComplianceRateThresholdKudo',
      'coachingDailyComplianceRateIssue',
      'coachingDailyComplianceRatePR',
      'coachingDailyComplianceRateCO',
      'coachingDailyComplianceRateKudo'
    ]
  },

  {
    name: 'PPS-Weekly',
    displayName: 'PPS Weekly Settings',
    fields: [
      // PpsBreaches fields  
      'coachingPpsBreachesThresholdIssue',
      'coachingPpsBreachesThreshold',
      'coachingPpsBreachesThresholdPR',
      'coachingPpsBreachesThresholdKudo',
      'coachingPpsBreachesIssue',
      'coachingPpsBreachesPR',
      'coachingPpsBreachesCO',
      'coachingPpsBreachesKudo',

      // PpsCompliancePercent fields
      'coachingPpsCompliancePercentThresholdIssue',
      'coachingPpsCompliancePercentThreshold',
      'coachingPpsCompliancePercentThresholdPR',
      'coachingPpsCompliancePercentThresholdKudo',
      'coachingPpsCompliancePercentIssue',
      'coachingPpsCompliancePercentPR',
      'coachingPpsCompliancePercentCO',
      'coachingPpsCompliancePercentKudo'
    ]
  },

  {
    name: 'PPS-Daily',
    displayName: 'PPS Daily Settings',
    fields: [
      // DailyPpsCompliancePercent fields
      'coachingDailyPpsCompliancePercentThresholdIssue',
      'coachingDailyPpsCompliancePercentThreshold',
      'coachingDailyPpsCompliancePercentThresholdPR',
      'coachingDailyPpsCompliancePercentThresholdKudo',
      'coachingDailyPpsCompliancePercentIssue',
      'coachingDailyPpsCompliancePercentPR',
      'coachingDailyPpsCompliancePercentCO',
      'coachingDailyPpsCompliancePercentKudo',

      // DailyPpsMissingBrake fields
      'coachingDailyPpsMissingBrakeThresholdIssue',
      'coachingDailyPpsMissingBrakeThreshold',
      'coachingDailyPpsMissingBrakeThresholdPR',
      'coachingDailyPpsMissingBrakeThresholdKudo',
      'coachingDailyPpsMissingBrakeIssue',
      'coachingDailyPpsMissingBrakePR',
      'coachingDailyPpsMissingBrakeCO',
      'coachingDailyPpsMissingBrakeKudo',

      // DailyPpsMissingGear fields
      'coachingDailyPpsMissingGearThresholdIssue',
      'coachingDailyPpsMissingGearThreshold',
      'coachingDailyPpsMissingGearThresholdPR',
      'coachingDailyPpsMissingGearThresholdKudo',
      'coachingDailyPpsMissingGearIssue',
      'coachingDailyPpsMissingGearPR',
      'coachingDailyPpsMissingGearCO',
      'coachingDailyPpsMissingGearKudo'
    ]
  },

  {
    name: 'CDF',
    displayName: 'Customer Delivery Feedback Settings',
    fields: [
      // DaMishandledPackage fields
      'coachingDaMishandledPackageThresholdIssue',
      'coachingDaMishandledPackageThreshold',
      'coachingDaMishandledPackageIssue',
      'coachingDaMishandledPackageCO',

      // DaWasUnprofessional fields
      'coachingDaWasUnprofessionalThresholdIssue',
      'coachingDaWasUnprofessionalThreshold',
      'coachingDaWasUnprofessionalIssue',
      'coachingDaWasUnprofessionalCO',

      // DaIgnoreInstructions fields
      'coachingDaIgnoreInstructionsThresholdIssue',
      'coachingDaIgnoreInstructionsThreshold',
      'coachingDaIgnoreInstructionsIssue',
      'coachingDaIgnoreInstructionsCO',

      // DeliveredToWrongAddress fields
      'coachingDeliveredToWrongAddressThresholdIssue',
      'coachingDeliveredToWrongAddressThreshold',
      'coachingDeliveredToWrongAddressIssue',
      'coachingDeliveredToWrongAddressCO',

      // NeverReceivedDelivery fields
      'coachingNeverReceivedDeliveryThresholdIssue',
      'coachingNeverReceivedDeliveryThreshold',
      'coachingNeverReceivedDeliveryIssue',
      'coachingNeverReceivedDeliveryCO',

      // ReceivedWrongItem fields
      'coachingReceivedWrongItemThresholdIssue',
      'coachingReceivedWrongItemThreshold',
      'coachingReceivedWrongItemIssue',
      'coachingReceivedWrongItemCO'
    ]
  }
];

/**
 * Auto-generate GraphQL fragments and queries for each template fragment
 * Clean and simple - no complex configuration needed
 */
TEMPLATE_FRAGMENTS.forEach(fragment => {
  // Generate GraphQL fragment name
  const fragmentName = fragment.name.replace(/-/g, '') + 'Fields';
  
  // Auto-generate GraphQL fragment
  fragment.graphqlFragment = `
    fragment ${fragmentName} on Tenant {
      ${fragment.fields.join('\n      ')}
    }
  `;

  // Auto-generate GraphQL query
  fragment.query = `
    ${fragment.graphqlFragment}
    query Get${fragment.name.replace(/-/g, '')}Template($id: ID!) {
      getTenant(id: $id) {
        ...${fragmentName}
      }
    }
  `;
});

/**
 * Helper function to extract coaching fields for a specific fragment from template data
 * @param {object} templateData - Complete template tenant object
 * @param {string} fragmentName - The fragment name
 * @returns {object} - Object containing only the coaching fields for the specified fragment
 */
export function extractFragmentFields(templateData, fragmentName) {
  const fragment = TEMPLATE_FRAGMENTS.find(f => f.name === fragmentName);
  if (!fragment) {
    console.warn(`No fragment found: ${fragmentName}`);
    return {};
  }

  const fragmentFields = {};

  fragment.fields.forEach(fieldName => {
    if (templateData[fieldName] !== undefined && templateData[fieldName] !== null) {
      fragmentFields[fieldName] = templateData[fieldName];
    }
  });

  // Only log when no fields are found to help debug missing data
  if (Object.keys(fragmentFields).length === 0) {
    console.warn(`No coaching fields found for fragment ${fragmentName}. Available keys:`, Object.keys(templateData || {}));
  }

  return fragmentFields;
}

/**
 * Get all unique coaching field names across all fragments
 * @returns {string[]} - Array of all coaching field names
 */
export function getAllCoachingFields() {
  const allFields = new Set();

  TEMPLATE_FRAGMENTS.forEach(fragment => {
    fragment.fields.forEach(field => {
      allFields.add(field);
    });
  });

  return Array.from(allFields).sort();
}